module.exports = __webpack_public_path__ + "img/charleston-hub.be993320.png";